module.exports = __webpack_public_path__ + "static/media/mini-tornillos.74319fb8.png";